module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_1.70c53486.svg";